module.exports = __webpack_public_path__ + "9c829ee8a266848f9c889156cbbae5f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-1024.jpg
// module id = 195
// module chunks = 0